import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { OrderCancelAdapter } from './adapters/order-cancel.adapter';
import { OccOrderCancelAdapter } from './adapters/impl/occ-order-cancel.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: OrderCancelAdapter,
            useClass: OccOrderCancelAdapter,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class OccModule {
}
